import { render, staticRenderFns } from "./CriarUsuario.vue?vue&type=template&id=031db768&scoped=true"
import script from "./CriarUsuario.vue?vue&type=script&lang=js"
export * from "./CriarUsuario.vue?vue&type=script&lang=js"
import style0 from "./CriarUsuario.vue?vue&type=style&index=0&id=031db768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031db768",
  null
  
)

export default component.exports